module.exports = __webpack_public_path__ + "static/media/track.cbee92e0.svg";